(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.getElementById('sticky-atc');
    var btn = document.getElementById('sticky-atc-btn');
    var textEl = document.getElementById('sticky-atc-text');
    var priceEl = document.getElementById('sticky-atc-price');

    if (!bar || !btn) return;

    function getRealBtn() {
      return document.querySelector('[data-product-form] [data-add-to-cart]');
    }

    function syncState() {
      var realBtn = getRealBtn();
      if (!realBtn) return;

      var realText = realBtn.querySelector('[data-add-to-cart-text]');
      var realPrice = realBtn.querySelector('[data-button-price]');

      if (realText && textEl) {
        textEl.textContent = realText.textContent.trim();
      }
      if (realPrice && priceEl) {
        priceEl.textContent = realPrice.textContent.trim();
      }

      btn.disabled = realBtn.disabled;
    }

    function init() {
      var realBtn = getRealBtn();
      if (!realBtn) return;

      // Show only after the real button has been scrolled above the viewport.
      // Stays hidden on initial load and while the real button is below the fold.
      var visibilityObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var rootTop = entry.rootBounds ? entry.rootBounds.top : 0;
        var scrolledPast = entry.boundingClientRect.bottom < rootTop;
        var shouldShow = !entry.isIntersecting && scrolledPast;
        bar.classList.toggle('is-hidden', !shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }, { threshold: 0 });

      visibilityObserver.observe(realBtn);

      // Sync text/price whenever the real button DOM changes (Alpine.js updates)
      var mutationObserver = new MutationObserver(syncState);
      mutationObserver.observe(realBtn, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled']
      });

      syncState();
    }

    // Clicking the sticky button triggers the real form submit
    btn.addEventListener('click', function () {
      var realBtn = getRealBtn();
      if (realBtn && !realBtn.disabled) {
        realBtn.click();
      }
    });

    // Listen for variant changes emitted by the theme
    document.addEventListener('theme:variant:change', syncState);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
